import { FC, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { parse } from 'query-string'
import { cn } from '@bem-react/classname'

import { Memo } from '@/hoc/Memo'
import { useAppDispatch } from '@/core/store/hooks'
import { UserEmailCompleteValidationModel } from '../AccountPage/models/UserModel'
import useBackendError from '@/hooks/useBackendError'
import {
  changeAuth,
  completeVerificationThunk,
} from '../AccountPage/store/accont.slice'
import { changeLoading } from '@/core/services/Loading/store/loading.slice'

import { Title } from '@/components/Title'
import { Button } from '@/components/Button'

import './styles/VerificationPage.scss'

const cnVerification = cn('Verification')

export const VerificationPage: FC = Memo(() => {
  const { t } = useTranslation('translation')
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { search } = useLocation()
  const [setBackendError] = useBackendError()

  const [isVerificated, setVerificated] = useState<boolean>(false)
  const [isLoad, setLoad] = useState<boolean>(false)

  useEffect(() => {
    localStorage.removeItem('token')
    dispatch(changeAuth(false))
  }, [])

  const completeVerification = useCallback(
    async (query: UserEmailCompleteValidationModel) => {
      try {
        await dispatch(completeVerificationThunk(query)).unwrap()
        dispatch(changeLoading(false))
        setVerificated(true)
        setLoad(true)
      } catch (errors) {
        setBackendError(errors)
        dispatch(changeLoading(false))
        setVerificated(false)
        setLoad(true)
      }
    },
    [],
  )

  useEffect(() => {
    dispatch(changeLoading(true))
    const { userId, token } = parse(search)
    if (userId && token) {
      completeVerification({
        userId,
        token,
      } as UserEmailCompleteValidationModel)
    }
  }, [search])

  const goToLogin = useCallback(() => {
    const query = parse(search)

    navigate(
      query && query.companyCode ? `/?companyCode=${query.companyCode}` : '/',
    )
  }, [])

  return (
    <>
      <Helmet>
        <title>{t('Verification email')} | Registration</title>
      </Helmet>

      {isLoad && (
        <div className={cnVerification()}>
          <Title>
            {isVerificated
              ? t('Your Email was verificated')
              : t('Email verification error')}
          </Title>
          {!isVerificated && (
            <div className={cnVerification('text')}>
              {t('Try the link from the post again')}
            </div>
          )}

          <div className={cnVerification('btn')}>
            <Button large onClick={goToLogin}>
              {t('Confirm')}
            </Button>
          </div>
        </div>
      )}
    </>
  )
})
